export default {
  path: '/opd-report',
  component: () => import('@/views/opdReport/opd-router.vue'),
  children: [
    {
      path: '',
      name: 'OpdReport',
      component: () => import('@/views/opdReport/pages/OpdReport.vue'),
      meta: {
        name: 'navigationDrawer.opdReport',
        icon: '/icons/opd.svg',
        auth: true
      }
    },
    {
      path: 'opd-detail/:id',
      name: 'OpdDetail',
      component: () => import('@/views/opdReport/pages/OpdDetail.vue'),
      meta: {
        name: 'navigationDrawer.opdReport',
        icon: '/icons/opd.svg',
        auth: true
      }
    },
    {
      path: 'medical-certificate',
      name: 'MedicalCertificateOPD',
      component: () => import('@/views/opdReport/pages/PrintOPD/MedicalCertificate.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: 'medical-certificate-small/:id',
      name: 'MedicalCertificateSmallOPD',
      component: () => import('@/views/opdReport/pages/PrintOPD/MedicalCertificateSmall.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: 'treatment-certificates/:id',
      name: 'TreatmentCertificates',
      component: () => import('@/views/opdReport/pages/PrintOPD/TreatmentCertificate.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: 'print-opd/:id',
      name: 'PrintOPD',
      component: () => import('@/views/opdReport/pages/PrintOPD/PrintOPD.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: 'print-prescription/:id',
      name: 'PrintPrescription',
      component: () => import('@/views/opdReport/pages/PrintOPD/PrintPrescription.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    }

  ]
}
